import React, { useEffect, useState } from "react"
import { Card, CardContent, Dropdown, Image } from "semantic-ui-react"
import { useTranslation, withTranslation } from "react-i18next"
import { saveTireDetails } from "../../actions/tire_action/tiresActions"
import { connect } from "react-redux"
import LoadingComponent from "../../components/shared/LoadingComponent"
import { DEFAULT_TIRE_QUENTY } from "../../constants/tires"
import { navigationPaths } from "../../constants/paths"
import { formatPrice } from "../../helpers/numberHelpers"
import { numberFormatToCurrency } from "../../components/tires/currency"
import { TiresBottomNav } from "../../layouts/TiresLayout"
import { gaJSON, trackFirebaseAnalytics } from "../../helpers/googleAnalyticsHelpers"

function TireDetails({
  saveTireDetails,
  selectedTire,
  dispatch,
  history,
  cartTire,
  cartTireQuantity,
  vehicle,
  user
}) {
  const [isLoading, setIsLoading] = useState(true)
  const [characteristic, setCharacteristic] = useState([])
  const [feature, setFeature] = useState([])
  const [benefit, setBenefit] = useState([])
  const quantity =
    selectedTire && selectedTire.stock.filter((item) => item.tireId === selectedTire.id).length > 0
      ? selectedTire.stock.filter((item) => item.tireId === selectedTire.id)[0].quantity
      : DEFAULT_TIRE_QUENTY
  const [selectedTireQty, setSelectedTireQty] = useState(
    cartTire && cartTireQuantity ? cartTireQuantity : quantity
  )
  const { t } = useTranslation("tierDetails")
  const objectCollection = [
    { id: 1, label: "1" },
    { id: 2, label: "2" },
    { id: 3, label: "3" },
    { id: 4, label: "4" }
  ]

  const dataprovider = objectCollection.map((object) => {
    return { key: object.id, value: object, text: object.label }
  })

  useEffect(() => {
    getTireDetails()
  }, [])

  const getTireDetails = async () => {
    if (selectedTire) {
      let features = selectedTire.marketing.features
      if (features && features.length > 0) {
        features.map((item) => {
          if (item.characteristic) {
            setCharacteristic((old) => [...old, item.characteristic])
          }
          if (item.feature) {
            setFeature((old) => [...old, item.feature])
          }
          if (item.benefit) {
            setBenefit((old) => [...old, item.benefit])
          }
        })
      }
      setIsLoading(false)
    }
  }

  const changeHandler = (event, data) => {
    setSelectedTireQty(data.value.id)
  }

  const isTireSelected = () => {
    return cartTire && cartTire.id === selectedTire.id
  }
  const SpecRow = ({ label, value, children, isBackground }) => (
    <div className={isBackground ? "about-tire-row-background" : "about-tire-row"}>
      <div className="about-tire-black-bold">{label}</div>
      <div>{children ? children : <span>{value}</span>}</div>
    </div>
  )

  const nextClick = () => {
    if (!selectedTire.id) return
    dispatch({
      type: "TIRE_CART_ITEM",
      payload: {
        cartTireObject: selectedTire,
        tireQuantity: selectedTireQty
      }
    })
    trackFirebaseAnalytics({
      event: gaJSON.add_to_cart_from_details,
      params: {
        vehicle_id: vehicle.id,
        user_role: user.roles.toString(),
        source: selectedTire.supplier === "tirehubdropship" ? "TireHub" : "NTW"
      }
    })

    history.push({
      pathname: navigationPaths.tireSelectShop()
    })
  }
  return (
    <>
      <h2 className="text-lg font-semibold !my-4 text-center tires-step-header">
        {t("tiresDetails")}
      </h2>
      <div className="tire-details-screen">
        <div className="tire-details-parent">
          {isLoading ? (
            <LoadingComponent />
          ) : (
            <div className="tire-details">
              <div className="card-parent">
                <Card className="tire-card-details">
                  <div className="tire-card-section">
                    <div className="content-parent">
                      <div className="tire-info-header-left">
                        <div className="tire-name-parent">
                          <div className="tire-name">
                            <span className="about-tire-black-bold">
                              {selectedTire && selectedTire.brand + " " + selectedTire.model}
                            </span>
                          </div>
                        </div>
                        {selectedTire && selectedTire.brand_logo ? (
                          <div className="logo-parent">
                            <Image src={selectedTire.brand_logo} />
                          </div>
                        ) : null}
                      </div>
                      {feature && feature.length > 0 ? (
                        <div>
                          <div className="tire-details-heading">
                            <span>{t("Features")}</span>
                          </div>
                          <div className="characteristics">
                            <ul>
                              {feature.map((item) => {
                                return <li>{item}</li>
                              })}
                            </ul>
                          </div>
                        </div>
                      ) : null}
                      {benefit && benefit.length > 0 ? (
                        <div>
                          <div className="tire-details-heading">
                            <span>{t("Benefits")}</span>
                          </div>
                          <div className="characteristics">
                            <ul>
                              {benefit.map((item) => {
                                return <li>{item}</li>
                              })}
                            </ul>
                          </div>
                        </div>
                      ) : null}
                      {characteristic && characteristic.length > 0 ? (
                        <div>
                          <div className="tire-details-heading">
                            <span>{t("Characteristics")}</span>
                          </div>
                          <div className="characteristics">
                            <ul>
                              {characteristic.map((item) => {
                                return <li>{item}</li>
                              })}
                            </ul>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div className="about-parent">
                      <div className="tire-info-header">
                        <span>{t("tire-specs")}</span>
                      </div>

                      <div className="tire-info">
                        <div className="tire-info-column">
                          <SpecRow
                            label={t("load-range")}
                            value={selectedTire.load_range ?? "-"}
                            isBackground={false}
                          />
                          <SpecRow
                            label={t("speed-rating")}
                            value={selectedTire.speed_rating}
                            isBackground={true}
                          />
                          <SpecRow
                            label={t("section-width")}
                            value={selectedTire.size_w}
                            isBackground={false}
                          />
                          <SpecRow label={t("max-psi")} value="-" isBackground={true} />
                          <SpecRow
                            label={t("rim-diameter")}
                            value={parseInt(selectedTire.size_r) * 2}
                            isBackground={false}
                          />
                          <SpecRow
                            label={t("tire-size")}
                            value={selectedTire.tire}
                            isBackground={false}
                          />
                        </div>
                        <div className="tire-info-column">
                          <SpecRow
                            label={t("load-index")}
                            value={selectedTire.load_index}
                            isBackground={false}
                          />
                          <SpecRow label={t("overall-diameter")} value="-" isBackground={true} />
                          <SpecRow
                            label={t("tread-depth")}
                            value={selectedTire.tread_depth}
                            isBackground={false}
                          />
                          <SpecRow label={t("weight")} value="-" isBackground={true} />
                          <SpecRow label={t("aspect-ration")} value="-" isBackground={false} />
                          <SpecRow label={t("sidewall-desc")} value="-" isBackground={false} />
                        </div>
                      </div>

                      <CardContent>
                        <div className="qty-box">
                          <div className="qty">{t("Qty")}:</div>
                          <Dropdown
                            options={dataprovider}
                            onChange={(event, data) => changeHandler(event, data)}
                            className="qty-dropdown"
                            placeholder={cartTire && cartTireQuantity ? cartTireQuantity : quantity}
                          />
                        </div>
                        <div className="price-box">
                          <div className="price">
                            ${selectedTire && formatPrice(selectedTire.price)}
                          </div>
                          <div className="price-for-set">
                            {selectedTire &&
                            selectedTire.stock.filter((item) => item.tireId === selectedTire.id)
                              .length > 0
                              ? `${numberFormatToCurrency(
                                  selectedTire && selectedTire.price * selectedTireQty
                                )} ${t("set_of")} ${selectedTireQty}`
                              : `${numberFormatToCurrency(
                                  selectedTireQty * selectedTire.price
                                )} ${t("set_of")} ${selectedTireQty}`}
                          </div>
                        </div>
                      </CardContent>
                      <div className="card-btn" onClick={nextClick}>
                        <p className={isTireSelected() ? "shop-btn-disabled" : "shop-btn"}>
                          {isTireSelected() ? t("addedToCartLabel") : t("Add_to_Cart")}
                        </p>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          )}
        </div>
      </div>
      <TiresBottomNav
        goBack={() => history.goBack()}
        nextBtnText={"Continue to tire installation"}
        nextDisabled={cartTire && cartTire.id === selectedTire.id}
        next={nextClick}
      />
    </>
  )
}

function mapStateToProps(state) {
  let selectedTire = state.tires.tireDetailsObject ?? []
  let cartTire = state.tires.tireDetails ?? {}
  let cartTireQuantity = state.tires.tireQuantity ?? 4
  const user = state.application.userSessionData || (state.users && state.users.currentUser)
  let vehicle = state.tires.vehicle ?? {}

  return {
    selectedTire: selectedTire,
    cartTire: cartTire,
    cartTireQuantity: cartTireQuantity,
    vehicle: vehicle,
    user: user
  }
}

export default connect(mapStateToProps, { saveTireDetails, dispatch: (action) => action })(
  withTranslation("tireDetails")(TireDetails)
)
